import React from 'react';
import { motion } from 'framer-motion';
const partnerLogos = [{
  name: 'Feastables',
  logo: 'https://cdn.magicpatterns.com/uploads/8MuQibPNcYATurCBTSPRsh/FEASTABLES.png'
}, {
  name: 'Lowes',
  logo: 'https://cdn.magicpatterns.com/uploads/mFr8okh37RRAq1X31tv4Z8/LOWES.png'
}, {
  name: 'Starbucks',
  logo: 'https://cdn.magicpatterns.com/uploads/7jWso1vUw27TBCeyRsFNr5/STARBUCKS.png'
}, {
  name: 'Eleiko',
  logo: 'https://cdn.magicpatterns.com/uploads/522JJhseboUNTCdxmo3Hkc/ELEIKO.png'
}, {
  name: 'Jack Links',
  logo: 'https://cdn.magicpatterns.com/uploads/fUrPuH3wyZ71qSagTf9L82/JACK_LINKS.png'
}, {
  name: 'T-Mobile',
  logo: 'https://cdn.magicpatterns.com/uploads/nciBFZ9ekKqCJzieGkrTL1/TMOBILE.png'
}, {
  name: 'TurboTax',
  logo: 'https://cdn.magicpatterns.com/uploads/nvDbiCnXu2UpPyP8JpsZ6h/TURBOTAX.png'
}, {
  name: 'Aputure',
  logo: 'https://cdn.magicpatterns.com/uploads/c8vUyQGNRUSx6eKn2KWbYP/APUTURE.png'
}, {
  name: 'Dude Wipes',
  logo: 'https://cdn.magicpatterns.com/uploads/9xNtVYDKay1qJofeEBduJW/DUDE_WIPES.png'
}, {
  name: 'E-Z-GO',
  logo: 'https://cdn.magicpatterns.com/uploads/nbybwxgVnjoifAqgohy1XA/EZGO.png'
}, {
  name: 'Hyundai',
  logo: 'https://cdn.magicpatterns.com/uploads/fjNbQGvVFo3RHw4ZKM6f81/HYUNDAI.png'
}];
export function PartnersSection() {
  return <section className="w-full py-32 bg-white border-y border-gray-100" data-id="element-144">
      <div className="max-w-7xl mx-auto px-6" data-id="element-145">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-146">
          <img src="https://cdn.magicpatterns.com/uploads/82kfbiVuH9vNY1uDhGWsMv/MrBeast.png" alt="MrBeast Logo" className="h-16 md:h-20 object-contain mb-12 invert opacity-80" data-id="element-147" />

          <p className="text-base text-gray-400 uppercase tracking-[0.3em] mb-16 font-bold" data-id="element-148">
            Official Partners
          </p>

          <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-8 md:gap-10 lg:gap-12 items-center justify-items-center w-full" data-id="element-149">
            {partnerLogos.map((partner, index) => <motion.img key={index} src={partner.logo} alt={partner.name} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} whileHover={{
            scale: 1.1
          }} className="h-10 md:h-14 lg:h-16 object-contain grayscale hover:grayscale-0 transition-all duration-300 cursor-pointer" data-id="element-150" />)}
          </div>
        </motion.div>
      </div>
    </section>;
}